import { useRef } from "react";
import { useFormContext } from "react-hook-form";

export const useHandleTotalPercentCalculation = (fieldName: string) => {
  const { setValue } = useFormContext();

  const isFirstMount = useRef(true);

  const handleTotalPercentCalculated = (value: string) => {
    if (isFirstMount.current) {
      isFirstMount.current = false;
      return;
    }
    setValue(fieldName, value);
  };

  return handleTotalPercentCalculated;
};
